import { Injectable } from '@angular/core'
import { Actions, Effect, ofType } from '@ngrx/effects'
import { catchError, exhaustMap, map } from 'rxjs/operators'
import { of } from 'rxjs'
import { LoadTokeetAICharges, LoadTokeetAIChargesComplete } from './ai-charge.actions'
import { ActionFailed } from '@tokeet-frontend/utility'
import { AIChargeService } from './ai-charge.service'

@Injectable()
export class AIChargeEffects {
  @Effect()
  loadCharges$ = this.actions$.pipe(
    ofType(LoadTokeetAICharges),
    exhaustMap(() =>
      this.aiChargeService.charges().pipe(
        map((items) => LoadTokeetAIChargesComplete({ items })),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  constructor(private actions$: Actions, private aiChargeService: AIChargeService) {}
}
